export default {
      id: "exit-icon-usage",
      viewBox: "0 0 13 14",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#exit-icon",
      toString: function () {
        return this.url;
      }
    }